<template>
    <v-container grid-list-md fluid v-if="displayConfig">
        <v-row no-gutters class="pb-4">
            <v-col cols="1">
                <v-btn-icon
                    variant="flat"
                    size="small"
                    color="primary"
                    @click="closeImportMapping()"
                    v-if="displayReturnBtn"
                    icon="$navigate_before"
                />
            </v-col>
            <v-col cols="3" class="d-flex justify-center">
                <v-select
                    v-model="filter.typeSearch"
                    :items="importMappingType"
                    item-value="value"
                    label="filtrer"
                    class="mr-2"
                    clearable
                    :item-title="(item) => item.label"
                />
            </v-col>
            <v-col cols="6">
                <v-text-field
                    append-inner-icon="$clear"
                    data-cy="companiesTable-search"
                    v-model="filter.search"
                    @click:append-inner="filter.search = ''"
                />
            </v-col>
            <v-col cols="2" class="d-flex align-center justify-end">
                <v-btn rounded elevation="0" @click="openAddDialog()" size="small"> Ajouter </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :items="importMap"
            :headers="dataHeader"
            class="table"
            :height="height"
            :multi-sort="false"
            fixed-header
            hide-default-footer
            xs12
        >
            <template v-slot:item.company="{ item }">
                <v-row no-gutters class="d-flex justify-center align-center">
                    <v-col cols="3">
                        <v-btn-icon
                            icon="$oss-edit"
                            @click="openEditDialog(item)"
                            elevation="0"
                            color="calendar_green"
                            :disabled="false"
                            size="small"
                        />
                    </v-col>
                    <v-col cols="9">
                        {{ item.company.name }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.origin="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.application="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.type="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.externalId="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.sourceName="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.sourceSiret="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.sourceIban="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.source="{ item }">
                <v-btn-trash @click="deleteImportMapping(item)" size="small" />
            </template>
            <template #top>
                <v-row no-gutters class="d-flex justify-end border-b">
                    <v-spacer />
                    <v-col cols="3" class="d-flex justify-end align-center">
                        <v-select
                            v-model="filter.pagination.rowsPerPage"
                            :items="[5, 10, 25]"
                            hide-details
                            class="top-pagination"
                            style="min-width: 170px"
                            prefix="Lignes par page"
                        />
                        <span style="white-space: nowrap">
                            {{ (filter.pagination.page - 1) * filter.pagination.rowsPerPage + 1 }}
                            -
                            {{
                                (filter.pagination.page - 1) * filter.pagination.rowsPerPage +
                                filter.pagination.rowsPerPage
                            }}
                            de {{ filter.pagination.totalItems }}
                        </span>
                        <v-btn-prev
                            @click="filter.pagination.page--"
                            :disabled="filter.pagination.page === 1"
                            size="small"
                        />
                        <v-btn-next
                            @click="filter.pagination.page++"
                            size="small"
                            :disabled="nextPageDisabled"
                        />
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        <!-- Ajout/modification -->
        <oss-dialog
            v-model="dialog"
            title="Interface d'import"
            :actions="actions"
            v-if="dialog"
            width="80vw"
        >
            <v-window style="min-width: 650px">
                <v-window-item>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <ossCompanySelector
                                v-model="selectId"
                                :items="allAvailableCompanies"
                                :selectClass="'oss-dark'"
                                @update:model-value="changeCompanyId()"
                                :disabled="true"
                                :chipMaxLength="9"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pb-2">
                        <v-col cols="3">
                            <v-select-filled
                                v-model="newImport.origin"
                                :items="originEnum"
                                label="Origine"
                                class="mr-2"
                                clearable
                                :disabled="disableDialog"
                            />
                        </v-col>
                        <v-col cols="9">
                            <v-text-field-filled
                                v-model="newImport.application"
                                label="Application"
                                class="ml-2"
                                hide-details
                                :disabled="disableDialog"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="py-2">
                        <v-col cols="3">
                            <v-select-filled
                                v-model="newImport.type"
                                :items="importMappingType"
                                item-value="value"
                                label="Type"
                                class="mr-2"
                                @update:model-value="changeType"
                                clearable
                                :disabled="edit"
                                :item-title="(item) => item.label"
                            />
                        </v-col>
                        <v-col cols="9">
                            <v-text-field-filled
                                label="Id externe"
                                v-model="newImport.externalId"
                                class="ml-2"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="py-2">
                        <v-col cols="6">
                            <v-text-field-filled
                                v-model="newImport.sourceName"
                                label="Source (Nom)"
                                class="mr-2"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="6" v-if="importMappingType[2].value === newImport.type">
                            <v-text-field-filled
                                v-model="newImport.sourceSiret"
                                label="Source (Siret)"
                                @input="onInputSetTruncatedSiret()"
                                class="ml-2"
                                hide-details
                                maxlength="14"
                            />
                        </v-col>
                        <v-col cols="6" v-if="importMappingType[3].value === newImport.type">
                            <v-text-field-filled
                                v-model="newImport.sourceIban"
                                label="Source (IBAN)"
                                @input="onInputSetTruncatedIban()"
                                class="ml-2"
                                hide-details
                                maxlength="32"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2">
                        <v-col cols="12" v-if="importMappingType[1].value === newImport.type">
                            <AccountableAccount
                                :showLabel="true"
                                :hideDetails="true"
                                @update:model-value="setAccountableAccount(newImport, $event)"
                                :defineThirdParty="false"
                                :inAccountableAccount="searchAccount"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="
                                importMappingType[0].value === newImport.type ||
                                importMappingType[2].value === newImport.type ||
                                importMappingType[3].value === newImport.type
                            "
                        >
                            <v-input
                                class="v-input v-input--is-label-active v-input--is-dirty v-input--is-readonly v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
                                @click.stop="dialogSelect = true"
                                density="compact"
                                hide-details
                                style="
                                    background-color: rgb(var(--v-theme-background));
                                    border-radius: 16px;
                                "
                                :label="newImport.sourceName ? '' : selectedLabel"
                            >
                                <v-row no-gutters class="py-2 px-4">
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                        style="white-space: nowrap; font-size: 1.1rem; color: black"
                                        v-if="newImport.userId"
                                    >
                                        {{
                                            this.newImport.userId.firstname +
                                            " " +
                                            this.newImport.userId.lastname
                                        }}
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                        style="white-space: nowrap"
                                        v-if="newImport.thirdPartyCompanyId"
                                    >
                                        {{ this.newImport.thirdPartyCompanyId.name }}
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                        style="white-space: nowrap"
                                        v-if="newImport.bankAccountId"
                                    >
                                        {{ this.newImport.bankAccountId.name }}
                                    </v-col>
                                </v-row>
                            </v-input>
                        </v-col>
                        <oss-dialog
                            v-model="dialogSelect"
                            title="Sélection"
                            v-if="dialogSelect"
                            width="60vw"
                        >
                            <v-row no-gutters style="min-width: 500px">
                                <v-col
                                    cols="12"
                                    v-if="importMappingType[0].value === newImport.type"
                                >
                                    <SelectUser
                                        v-model="newImport.userId"
                                        :companyId="newImport.companyId"
                                        :height="'40vh'"
                                        :availableCompanyId="newImport.companyId"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="importMappingType[2].value === newImport.type"
                                >
                                    <CompaniesTable
                                        v-model="newImport.thirdPartyCompanyId"
                                        :parentCompanyId="currentCompany.id"
                                        :showGenericCompany="true"
                                        :showConsumerCompany="true"
                                        :showCustomerCompanies="true"
                                        :showSupplierCompanies="true"
                                        :showExistingCompanies="false"
                                        :showNewCompanies="false"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="importMappingType[3].value === newImport.type"
                                >
                                    <BankAccountSelector
                                        v-model="newImport.bankAccountId"
                                        :companyId="newImport.companyId"
                                    />
                                </v-col>
                            </v-row>
                        </oss-dialog>
                    </v-row>
                </v-window-item>
            </v-window>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import ossCompanySelector from "./ossComponents/ossCompanySelector.vue";
import AccountableAccount from "./AccountableAccount.vue";
import SelectUser from "./user/SelectUser.vue";
import BankAccountSelector from "./bank/BankAccountSelector.vue";
import CompaniesTable from "./admin/CompaniesTable.vue";
import { truncateInput } from "@/helpers/formInput.helper";
import IMPORT_MAPPINGS from "../graphql/ImportMappings.gql";
import UPSERT_IMPORT_MAP from "../graphql/UpsertImportMapping.gql";
import DELETE_IMPORT_MAP from "../graphql/DeleteImportMapping.gql";

import { getImportMapQuery } from "../services/graphqlServices";
import { DialogAction } from "../services/dialogAction";
import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccount,
        BankAccountSelector,
        SelectUser,
        ossCompanySelector,
        CompaniesTable,
    },
    emits: ["closeImportMapping"],
})
export class ImportMapping extends Vue {
    @Prop({ default: true }) displayReturnBtn: boolean;
    @Prop({ default: "72vh" }) height: string;
    @Prop({ default: null }) specificQuery: any;

    dialog = false;
    dialogSelect = false;
    edit = false;
    searchAccount = "";
    selectId = {
        id: "",
    };

    displayConfig = true;

    actions = { action: new DialogAction() };

    newImport = {
        id: "",
        companyId: "",
        origin: "",
        application: "",
        type: "",
        externalId: "",
        sourceName: "",
        sourceSiret: "",
        sourceIban: "",
        sourceDescription: "",
        accountableAccountId: {
            id: "",
            name: "",
            description: "",
        },
        userId: {
            id: "",
            lastname: "",
            firstname: "",
        },
        bankAccountId: {
            id: "",
            name: "",
            iban: "",
        },
        thirdPartyCompanyId: {
            id: "",
            name: "",
            siret: "",
        },
    };

    updateImport = {
        updateCompanyId: "",
        updateAccountableAccountId: "",
        updateUserId: "",
        updateBankAccountId: "",
        updateThirdPartyCompanyId: "",
    };

    dataHeader = [
        { title: "Company", value: "company", sortable: false },
        { title: "Origin", value: "origin", sortable: false },
        { title: "Application", value: "application", sortable: false },
        { title: "Type", value: "type", sortable: false },
        { title: "ExternalId", value: "externalId", sortable: false },
        { title: "Source (Nom)", value: "sourceName", sortable: false },
        { title: "Source (Siret)", value: "sourceSiret", sortable: false },
        { title: "Source (IBAN)", value: "sourceIban", sortable: false },
        { title: "Source (Description)", value: "sourceDescription", sortable: false },
        { title: "", value: "source", sortable: false },
    ];

    importMappingType = [
        { value: "USER", label: "Utilisateur" },
        { value: "ACCOUNTABLE_ACCOUNT", label: "Compte responsable" },
        { value: "THIRD_PARTY_COMPANY", label: "Société tierce" },
        { value: "BANK_ACCOUNT", label: "Compte bancaire" },
    ];

    originEnum = ["EVOLIZ"];

    filter = {
        search: "",
        typeSearch: "",
        pagination: {
            page: 1,
            descending: [true],
            rowsPerPage: 10,
            totalItems: 0,
        },
    };

    get nextPageDisabled() {
        return (
            Math.ceil(this.filter.pagination.totalItems / this.filter.pagination.rowsPerPage) <=
            this.filter.pagination.page
        );
    }

    get allAvailableCompanies() {
        return this.$store.state.user.allAvailableCompanies;
    }

    get currentCompany() {
        return this.$store.state.selected_company;
    }

    get selectedLabel() {
        switch (this.newImport.type) {
            case this.importMappingType[0].value:
                return this.importMappingType[0].label;
            case this.importMappingType[2].value:
                return this.importMappingType[2].label;
            case this.importMappingType[3].value:
                return this.importMappingType[3].label;
            default:
                return null;
        }
    }

    get validBtn() {
        if (
            this.newImport.origin &&
            this.newImport.application &&
            this.newImport.type &&
            this.newImport.sourceName
        ) {
            switch (this.newImport.type) {
                case this.importMappingType[0].value:
                    if (this.newImport.userId) {
                        return false;
                    }
                    break;
                case this.importMappingType[1].value:
                    if (this.newImport.accountableAccountId) {
                        return false;
                    }
                    break;
                case this.importMappingType[2].value:
                    if (this.newImport.thirdPartyCompanyId) {
                        return false;
                    }
                    break;
                case this.importMappingType[3].value:
                    if (this.newImport.bankAccountId) {
                        return false;
                    }
                    break;
                default:
                    return true;
            }
        }
        return true;
    }

    get disableDialog() {
        if (this.specificQuery) {
            return true;
        }
        return false;
    }

    @Watch("dialogSelect")
    sourceInput() {
        if (this.newImport.type && !this.dialogSelect) {
            switch (this.newImport.type) {
                case this.importMappingType[0].value:
                    if (this.newImport.userId.lastname || this.newImport.userId.firstname) {
                        this.newImport.sourceName = this.newImport.userId.lastname.concat(
                            " " + this.newImport.userId.firstname,
                        );
                    }
                    break;
                case this.importMappingType[2].value:
                    this.newImport.sourceName = this.newImport.thirdPartyCompanyId.name;
                    this.newImport.sourceSiret = this.newImport.thirdPartyCompanyId.siret;
                    break;
                case this.importMappingType[3].value:
                    this.newImport.sourceName = this.newImport.bankAccountId.name;
                    this.newImport.sourceIban = this.newImport.bankAccountId.iban;
                    break;
                default:
                    break;
            }
        }
    }

    @Watch("newImport.accountableAccountId")
    sourceAccountableAccount() {
        if (this.newImport.type === this.importMappingType[1].value) {
            this.newImport.sourceName = this.newImport.accountableAccountId.name;
            this.newImport.sourceDescription = this.newImport.accountableAccountId.description;
        }
    }
    clearImport() {
        this.searchAccount = "";
        this.selectId = {
            id: "",
        };
        this.newImport = {
            id: "",
            companyId: "",
            origin: "",
            application: "",
            type: "",
            externalId: "",
            sourceName: "",
            sourceSiret: "",
            sourceIban: "",
            sourceDescription: "",
            accountableAccountId: {
                id: "",
                name: "",
                description: "",
            },
            userId: {
                id: "",
                lastname: "",
                firstname: "",
            },
            bankAccountId: {
                id: "",
                name: "",
                iban: "",
            },
            thirdPartyCompanyId: {
                id: "",
                name: "",
                siret: "",
            },
        };
        this.updateImport = {
            updateCompanyId: "",
            updateAccountableAccountId: "",
            updateUserId: "",
            updateBankAccountId: "",
            updateThirdPartyCompanyId: "",
        };
    }

    changeType() {
        this.newImport.accountableAccountId = {
            id: "",
            name: "",
            description: "",
        };
        this.newImport.userId = {
            id: "",
            lastname: "",
            firstname: "",
        };
        this.newImport.bankAccountId = {
            id: "",
            name: "",
            iban: "",
        };
        this.newImport.thirdPartyCompanyId = {
            id: "",
            name: "",
            siret: "",
        };
        this.newImport.sourceName = "";
        this.newImport.sourceIban = "";
        this.newImport.sourceSiret = "";
        this.newImport.sourceDescription = "";
    }

    changeCompanyId() {
        this.newImport.companyId = this.selectId.id;
    }

    setAccountableAccount(item, data) {
        item.accountableAccountId = JSON.parse(JSON.stringify(data));
    }

    onInputSetTruncatedSiret() {
        this.newImport.sourceSiret = truncateInput(this.newImport.sourceSiret, 14);
    }

    onInputSetTruncatedIban() {
        this.newImport.sourceIban = truncateInput(this.newImport.sourceIban, 32);
    }
    openEditDialog(item) {
        this.newImport = {
            id: item.id,
            companyId: item.company.id,
            origin: item.origin,
            application: item.application,
            type: item.type,
            externalId: item.externalId,
            sourceName: item.sourceName,
            sourceSiret: item.sourceSiret,
            sourceIban: item.sourceIban,
            sourceDescription: item.sourceDescription,
            accountableAccountId: item.accountableAccount
                ? item.accountableAccount
                : { id: "", name: "", description: "" },
            userId: item.user ? item.user : { id: "", lastname: "", firstname: "" },
            bankAccountId: item.bankAccount ? item.bankAccount : { id: "", name: "", iban: "" },
            thirdPartyCompanyId: item.thirdPartyCompany
                ? item.thirdPartyCompany
                : { id: "", name: "", siret: "" },
        };
        if (item.accountableAccount) {
            this.searchAccount = item.accountableAccount;
        }
        this.selectId = item.company;
        this.edit = true;
        this.dialog = true;
    }

    openAddDialog() {
        if (this.specificQuery?.origin && this.specificQuery.application) {
            this.newImport.origin = this.specificQuery.origin;
            this.newImport.application = this.specificQuery.application;
        }
        if (this.edit) {
            this.clearImport();
            this.edit = false;
        }
        if (this.newImport.accountableAccountId) {
            this.searchAccount = this.newImport.accountableAccountId.id;
        }
        this.newImport.companyId = this.currentCompany.id;
        this.selectId = this.currentCompany;
        this.dialog = true;
    }

    @Apollo({
        query: IMPORT_MAPPINGS,
        variables() {
            return getImportMapQuery(this.filter, this.currentCompany, this.specificQuery);
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.importMap = JSON.parse(JSON.stringify(data.importMappings));
                this.filter.pagination.totalItems = data.importMappingsConnection.aggregate.count;
            } else {
                this.importMap = [];
            }
        },
    })
    importMap: any = [];

    async upsertImportMapping() {
        if (this.edit) {
            this.updateImport = {
                updateCompanyId: this.newImport.companyId,
                updateAccountableAccountId: this.newImport.accountableAccountId.id,
                updateUserId: this.newImport.userId.id,
                updateBankAccountId: this.newImport.bankAccountId.id,
                updateThirdPartyCompanyId: this.newImport.thirdPartyCompanyId.id,
            };
        }

        let check = await this.$apollo.mutate({
            mutation: UPSERT_IMPORT_MAP,
            variables: {
                id: this.newImport.id,
                companyId: this.newImport.companyId
                    ? { connect: { id: this.newImport.companyId } }
                    : null,
                origin: this.newImport.origin,
                application: this.newImport.application,
                type: this.newImport.type,
                externalId: this.newImport.externalId,
                sourceName: this.newImport.sourceName,
                sourceSiret: this.newImport.sourceSiret,
                sourceIban: this.newImport.sourceIban,
                sourceDescription: this.newImport.sourceDescription,

                updateCompanyId: this.updateImport.updateCompanyId
                    ? { connect: { id: this.updateImport.updateCompanyId } }
                    : undefined,
                updateAccountableAccountId: this.updateImport.updateAccountableAccountId
                    ? { connect: { id: this.updateImport.updateAccountableAccountId } }
                    : undefined,
                updateUserId: this.updateImport.updateUserId
                    ? { connect: { id: this.updateImport.updateUserId } }
                    : undefined,
                updateBankAccountId: this.updateImport.updateBankAccountId
                    ? { connect: { id: this.updateImport.updateBankAccountId } }
                    : undefined,
                updateThirdPartyCompanyId: this.updateImport.updateThirdPartyCompanyId
                    ? { connect: { id: this.updateImport.updateThirdPartyCompanyId } }
                    : undefined,

                accountableAccountId: this.newImport.accountableAccountId.id
                    ? { connect: { id: this.newImport.accountableAccountId.id } }
                    : undefined,
                userId: this.newImport.userId.id
                    ? { connect: { id: this.newImport.userId.id } }
                    : undefined,
                bankAccountId: this.newImport.bankAccountId.id
                    ? { connect: { id: this.newImport.bankAccountId.id } }
                    : undefined,
                thirdPartyCompanyId: this.newImport.thirdPartyCompanyId.id
                    ? { connect: { id: this.newImport.thirdPartyCompanyId.id } }
                    : undefined,
            },
        });

        if (check.data?.upsertImportMapping?.id) {
            this.$apollo.queries.importMap.refetch();
            this.closeDialog();
        }
    }

    closeImportMapping() {
        this.$emit("closeImportMapping");
    }

    closeDialog() {
        this.dialog = false;
        this.clearImport();
    }

    async deleteImportMapping(item) {
        try {
            await this.$apollo.mutate({
                mutation: DELETE_IMPORT_MAP,
                variables: {
                    id: item.id,
                },
            });

            // this.$apollo.queries.importMap.refetch()

            const index = this.importMap.findIndex((element) => element.id === item.id);
            if (index !== -1) {
                this.importMap.splice(index, 1);
            }
        } catch (error) {
            console.error("Erreur lors de la suppression de l'ImportMapping :", error);
        }
    }

    beforeMount() {
        if (this.actions?.action) {
            this.actions.action.function = this.upsertImportMapping;
            // @ts-ignore
            this.actions.action.disabled = () => {
                return !!this.validBtn;
            };
            this.actions.action.title = "Valider";
        }
    }
}

export default toNative(ImportMapping);
</script>

<style lang="scss">
.top-pagination {
    .v-text-field__prefix {
        font-size: 0.75rem !important;
        font-weight: bold;
    }
    .v-field {
        font-size: 0.875rem !important;
        font-weight: 500;
    }
}
</style>
